import React from 'react';
import classNames from 'classnames';
import { List } from 'immutable';

import { Button, Container } from '@uncinc/uncinc-react-kitchen-sink';
import { Paragraph } from '@uncinc/react-drupal-core';

import { WysiwygField, Breadcrumbs } from '../../../components';

import './style.scss';

const NodeBasicPage = ({ entity, className }) => {
  const classes = classNames(className, 'NodeBasicPage');
  const node = entity.toJS();
  const title = node.title[0].value;
  const body = node.body[0]?.processed;
  const primary_link = node.field_link[0]?.alias || node.field_link[0]?.uri;
  const primary_link_title = node.field_link[0]?.title;
  const secondary_link = node.field_link[1]?.alias || node.field_link[1]?.uri;
  const secondary_link_title = node.field_link[1]?.title;

  return (
    <article itemType="http://schema.org/WebPage" className={classes}>

      <Container>

        <Breadcrumbs includeCurrent />

        <div className="NodeBasicPage__hero">
          <h1 itemProp="name">{title}</h1>
          {body ? (
            <WysiwygField
              property="schema:text"
              html={body}
            />
          ) : null}
          {primary_link && (
            <div className="NodeBasicPage__links">
              <Button primary
                className="icon-after icon-arrow-right icon-variant-1"
                href={primary_link}
              >
                <span>{primary_link_title}</span>
              </Button>
              {secondary_link && (
                <Button
                  className="Button--secondary icon-after icon-arrow-right icon-variant-2"
                  href={secondary_link}
                >
                  <span>{secondary_link_title}</span>
                </Button>
              )}
            </div>
          )}


        </div>
      </Container>

      {entity.get('field_paragraphs') ? (
        <div className="NodeBasicPage__paragraphs">
          {entity.get('field_paragraphs', List()).map((paragraph) => {
            const id = paragraph.get('target_id');
            const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);

            return (
              <Paragraph
                key={`paragraph:${id}:${language}`}
                entity={paragraph.get('entity')}
              />
            );
          })}
        </div>
      ) : null}

    </article>
  );
};

export default NodeBasicPage;
